/** Field length rules for Add / Edit Member modal (primary + spouse). */

export const ADD_MEMBER_FIELD_LIMITS = {
  GENDER: 1,
  DATE_DISPLAY_CHARS: 10, // MM/DD/YYYY
  YEAR_DIGITS: 3,
  CELL_DIGITS: 10,
};

export const ADD_MEMBER_DATE_FORMAT = "MM/DD/YYYY";

const FOCUSABLE_SELECTOR = [
  "input:not([disabled]):not([readonly]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  ".dropdown-selection-cs input.modal-dropdown-cs",
  ".react-tel-input .form-control",
].join(", ");

export function getAddMemberModalRoot(fromElement) {
  if (!fromElement) return null;
  return (
    fromElement.closest(".addmember-card") ||
    fromElement.closest(".popup-card") ||
    document.querySelector(".addmember-card")
  );
}

/** Move focus to the next editable field in the add-member modal. */
export function focusNextField(fromElement) {
  const root = getAddMemberModalRoot(fromElement);
  if (!root) return;

  const nodes = Array.from(root.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (el) =>
      el.offsetParent !== null &&
      !el.closest(".MuiPickersPopper-root") &&
      !el.closest('[aria-hidden="true"]')
  );

  let current = fromElement;
  if (current.classList?.contains("react-tel-input")) {
    current = current.querySelector(".form-control") || current;
  }

  let idx = nodes.indexOf(current);
  if (idx === -1) {
    const group = current.closest?.(".form-group");
    if (group) {
      const inner = group.querySelector(FOCUSABLE_SELECTOR);
      if (inner) idx = nodes.indexOf(inner);
    }
  }
  if (idx === -1) return;

  for (let i = idx + 1; i < nodes.length; i += 1) {
    const next = nodes[i];
    if (!next || next.offsetParent === null) continue;
    next.focus();
    if (typeof next.select === "function") {
      try {
        next.select();
      } catch {
        /* read-only, etc. */
      }
    }
    break;
  }
}

export function sanitizeYearDigits(value) {
  return (value || "").replace(/\D/g, "").slice(0, ADD_MEMBER_FIELD_LIMITS.YEAR_DIGITS);
}

/** 3-digit entry (e.g. 026) → storage date YYYY/01/01 for validation pipeline. */
export function yearDigitsToStorageDate(yearDigits) {
  const digits = sanitizeYearDigits(yearDigits);
  if (digits.length < ADD_MEMBER_FIELD_LIMITS.YEAR_DIGITS) return "";
  const fullYear = `2${digits}`;
  return `${fullYear}/01/01`;
}

/** Storage date → 3-digit year segment for display (2026 → 026). */
export function storageDateToYearDigits(dateValue) {
  if (!dateValue) return "";
  const parts = String(dateValue).split(/[-/]/);
  let year = "";
  if (parts[0]?.length === 4) {
    year = parts[0];
  } else if (parts[2]?.length >= 2) {
    year = parts[2].length === 4 ? parts[2] : parts[2];
  }
  if (!year) return "";
  const y = parseInt(year, 10);
  if (Number.isNaN(y)) return "";
  return String(y).slice(-3).padStart(3, "0");
}

export function extractNationalPhoneDigits(value, dialCode = "") {
  const digits = String(value || "").replace(/\D/g, "");
  const code = String(dialCode || "").replace(/\D/g, "");
  if (code && digits.startsWith(code)) {
    return digits.slice(code.length, code.length + ADD_MEMBER_FIELD_LIMITS.CELL_DIGITS);
  }
  return digits.slice(0, ADD_MEMBER_FIELD_LIMITS.CELL_DIGITS);
}

export function limitNationalPhoneDigits(value, dialCode = "") {
  return extractNationalPhoneDigits(value, dialCode).slice(
    0,
    ADD_MEMBER_FIELD_LIMITS.CELL_DIGITS
  );
}
